import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';

const Tabs = ({active, setSelectedTab, auth}) => {
    let history = useHistory();

    const [tabsArray, setTabsArray] = useState([]);

    useEffect(() => {
        let arr = [];
        if(auth.permissions && auth.permissions.length > 0) {
            //if(auth.permissions.includes('vs')) {
            arr.push({
                icon: 'fa fa-cog',
                name: 'globe',
            });
            //} 
            //if(auth.permissions.includes('social')) {
            arr.push({
                    icon: 'fab fa-twitter',
                    name: 'twitter',
                    style: {color: '#1DA1F2'},
                },
                {
                    icon: 'fab fa-facebook',
                    name: 'facebook',
                    style: {color: '#4267B2'},
                },
                {
                    icon: 'fab fa-youtube',
                    name: 'youtube',
                    style: {color: '#FF0000'},
                },
                {
                    icon: 'fab fa-instagram',
                    name: 'instagram',
                },
                {
                    icon: 'fa fa-rss',
                    name: 'rss',
                    style: {color: '#ee802f'},
                });
            //}
        }
        setTabsArray(arr);
    }, [auth.permissions]);

    const handleTabChange = (name) => {
        setSelectedTab(name);
        history.push('/main/' + name);
    };

    return (
        <div className="tabs">
            {tabsArray.map((tab) => (
                <div
                    className={`tabs-item ${active === tab.name ? 'active' : ''} ${tab.name}`}
                    key={tab.name}
                    onClick={() => handleTabChange(tab.name)}
                    style={active === tab.name ? tab.style : {}}
                >
                    <i className={`${tab.icon} tabs-icon`}/>
                </div>
            ))}
        </div>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(Tabs);